import { useQueryCore } from "@/hooks/useQueryCore";
import { getPrayer } from "@/lib/api";

export function usePrayerDetail(id) {
  const { data, loading, error, refetch, setData } = useQueryCore({
    key: ["prayer-detail", id],
    enabled: !!id,
    queryFn: () => getPrayer(id),
    // Matches the Dexie key written by getPrayer() in api.js.
    cacheKey: id ? `prayer_${id}` : null,
  });

  const resolved = !Array.isArray(data);

  return {
    prayer: resolved ? data : null,
    loading: loading || !resolved,
    error,
    refetch,
    setPrayer: setData,
  };
}
